import { useNavigation, useRoute } from '@react-navigation/core'
import React, { useEffect, useState } from 'react'
import { ProgressDialog } from '../../comps/ProgressDialog'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { FAILED, SUCCESS } from '../../network/sendEvent'
import { nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import { getFingerPrintData, parseBioMetricDeviceInfo } from '../../util/utill'
import { FingerPrintScanner } from './FingerPrintScanner'

export const ScanFingerprintScreen = () => {
  const { updateIsAadhaarVarified, asyncAuthenticateBiometric, setBioMetricDeviceInfo, getConsent,sendEventAsync } = useStores(
    (root) => ({
      updateIsAadhaarVarified: root.agent.updateIsAadhaarVarified,
      asyncAuthenticateBiometric: root.agent.asyncAuthenticateBiometric,
      setBioMetricDeviceInfo: root.agent.setBioMetricDeviceInfo,
      getConsent: root.consents.getConsent,
      sendEventAsync: root.agent.session.sendEventAsync,
    }),
  )
  const route: any = useRoute()
  const navigation = useNavigation()
  const consent = getConsent('AGENT_FINGER_PRINT')
  const authModeRef = React.useRef(null)

  const otp = route.params?.otp
  const isFromEnterAadhaarCardScreen = route.params?.isFromEnterAadhaarCardScreen
  const [shouldShowFingerPrintModel, setShouldShowFingerPrintModel] = useState(false)
  const [lazyAsyncAuthenticateBiometric, asyncAuthenticateBiometricHandler] = useLazyApiData(asyncAuthenticateBiometric)
  const [fingerPrintError, setFingerPrintError] = useState({ code: '', error: '', title: '' })
  console.log("startscanfingerprintt::")
  const onScanSuccess = (sucess: any) => {
    console.log("lazyAsyncAuthenticateBiometric::")
    getFingerPrintData(sucess, consent, authModeRef.current).then((fingerprintData: any) => {
      setBioMetricDeviceInfo(parseBioMetricDeviceInfo(fingerprintData))
      sendEventAsync({
        status: 'FINGERPRINT_CAPTURED',
        biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
      })
      console.log("beforelazyscann:::")
      lazyAsyncAuthenticateBiometric(isFromEnterAadhaarCardScreen, otp, fingerprintData, consent, authModeRef?.current)
      setShouldShowFingerPrintModel(false)
    })
  }

  const onScanError = (error: any) => {
    sendEventAsync({
      status: 'FINGERPRINT_ERROR',
      errorDescription: error,
    })
    setFingerPrintError(JSON.parse(error))
  }
  const onFigerprintSubmit = (authMode: 'FACE' | 'FINGER_PRINT') => {
    setShouldShowFingerPrintModel(true)
    authModeRef.current = authMode
    if (window.AepsWebViewInterface) {
      nativeJSComm(nativeJSMapper.scanFingerPrint, onScanSuccess, onScanError, { authMode })
    } else {
      lazyAsyncAuthenticateBiometric(isFromEnterAadhaarCardScreen, otp, '')
    }
  }

  const reScanFingerPrint = (authenticationMode: 'FACE' | 'FINGER_PRINT') => {
    authModeRef.current = authenticationMode
    setFingerPrintError({ code: '', error: '', title: '' })
    nativeJSComm(nativeJSMapper.scanFingerPrint, onScanSuccess, onScanError, { authMode: authenticationMode })
  }

  useEffect(() => {
    if (asyncAuthenticateBiometricHandler.state === 'fulfilled') {
      updateIsAadhaarVarified()
    } else if (asyncAuthenticateBiometricHandler.state === 'rejected') {
      navigation.goBack()
    }

  }, [asyncAuthenticateBiometricHandler, navigation, updateIsAadhaarVarified])

  return (
    <>
      <FingerPrintScanner
        onSubmit={onFigerprintSubmit}
        isLoading={asyncAuthenticateBiometricHandler.state === 'pending'}
        consent={consent}
      />
      <ProgressDialog
        error={fingerPrintError}
        onRetry={reScanFingerPrint}
        show={shouldShowFingerPrintModel || asyncAuthenticateBiometricHandler.state === 'pending'}
        type={
          fingerPrintError.code
            ? 'error'
            : asyncAuthenticateBiometricHandler.state === 'pending'
            ? 'loader'
            : authModeRef.current==="FACE"?
            'face':
            'fingerprint'
        }
        onCancel={() => {
          setShouldShowFingerPrintModel(false)
          setFingerPrintError({ code: '', error: '', title: '' })
        }}
      />
    </>
  )
}
